const API_URL = process.env.REACT_APP_API_URL;

let apiUrls =  {
    elements: `${API_URL}/inks`,
    saveMileageSchedule: `${API_URL}/ink/save-mileage-schedule`,
    information: `${API_URL}/ink/information`
};

export default apiUrls;
